import classnames from 'classnames/bind'
import { useTranslation } from 'next-i18next'

// Libs
import { useLiveList } from '@/components/shared/LiveList/hooks/useLiveList'

// Components
import LiveList from '@/components/shared/LiveList'

// constants
import { isClientSideShopApp } from '@/utils/navigator'

// Styles
import styles from './style.module.scss'

const cx = classnames.bind(styles)

const HotLiveList = () => {
  const { t } = useTranslation()

  const liveListData = useLiveList({})
  const isShopApp = isClientSideShopApp

  return (
    <>
      {!isShopApp && liveListData?.isSuccess && liveListData?.data?.pages[0]?.totalPage?.totalPages > 0 && (
        <div className={cx('hot-live-list')}>
          <div className={cx('hot-live-list__title')}>{t('Common_Hot_LiveList')}</div>
          <div className={cx('hot-live-list__content')}>
            <LiveList liveListData={liveListData} />
          </div>
        </div>
      )}
    </>
  )
}

export default HotLiveList
